/**
 * SearchSpot -- empty-state spot illustration for a universal-search "no
 * results" state (#2580, Tier 5, EPIC #2575). A magnifier lens (accent ring +
 * handle) hovering over a faint list -- reads as "we looked, nothing matched".
 * Line-art on tokens, ~160x120, aria-hidden. Agency-neutral.
 */
import SpotIllustration from "./SpotIllustration";

export function SearchSpot({ className }: { className?: string }) {
  return (
    <SpotIllustration className={className}>
      {/* Faint list behind the lens */}
      <path
        d="M40 40h44M40 52h30M40 88h56M40 100h40"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.3"
      />
      {/* Magnifier lens (accent) */}
      <circle
        cx="86"
        cy="66"
        r="22"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
      {/* Magnifier handle */}
      <path
        d="M102 82 120 100"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
      {/* Empty "no match" dash inside the lens */}
      <path
        d="M78 66h16"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.5"
      />
    </SpotIllustration>
  );
}

export default SearchSpot;
